export default "__VITE_ASSET__8a45d752__"